import { createSelector } from "reselect";
import { AppState } from "@shared/interfaces";

const selectPresetBuilderState = (state: AppState) => state.presetBuilder;
export const getPresetBuilder = () => createSelector(selectPresetBuilderState, (state) => state);
